import { AfterViewChecked, AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import {
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    Validators
} from '@angular/forms';

import { Line } from '@app/shared/models/line.model';
import { LineLocation } from '@app/shared/models/line-location.model';
import { MultipleInputComponent } from '@app/shared/components/form/multiple-input/multiple-input.component';
import { Log } from 'ng2-logger';

@Component({
    selector: "app-line-transport-settings-form",
    templateUrl: "./line-transport-settings-form.component.html",
    styleUrls: ["./line-transport-settings-form.component.scss"]
})
export class LineTransportSettingsFormComponent implements OnInit, AfterViewInit {

    _logger = Log.create(LineTransportSettingsFormComponent.name);

    @Input() showValidations = false;

    @ViewChild(MultipleInputComponent, { static: false })
    multipleInputs: MultipleInputComponent;

    public line: Line;
    public transportForm: UntypedFormGroup;
    public lineLocations: LineLocation[];

    private pendingLine: Line | null = null;
    private viewInitialized = false;

    constructor(private fb: UntypedFormBuilder) {}

    get isFormValid() {
        return (
            this.transportForm.valid &&
            this.multipleInputs &&
            this.multipleInputs.isValid
        );
    }

    ngOnInit() {
        this.lineLocations = [];
        this.transportForm = this.fb.group({
            maxTransportTime: new UntypedFormControl(null, [
                Validators.required,
                Validators.min(1)
            ]),
            lineLocations: new UntypedFormControl([], Validators.required)
        });
    }

    ngAfterViewInit() {
        this.viewInitialized = true;

        if (this.pendingLine) {
            this.initialize(this.pendingLine);
            this.pendingLine = null;
        }
    }

    async init(line: Line) {
        if (!line) return;

        if (!this.viewInitialized) {
            this.pendingLine = line;
        } else {
            this.initialize(line);
        }
    }

    private initialize(line: Line) {
        this.line = line;

        this.lineLocations = line.lineLocations || [];

        this.multipleInputs?.init(this.lineLocations);

        this.transportForm.patchValue({
            maxTransportTime: line.toolMaxTransportTime,
            lineLocations: this.lineLocations
        });
    }

    getFormTransportData() {
        const raw = this.transportForm.getRawValue();
        return {
            toolMaxTransportTime: raw.maxTransportTime,
            lineLocations: raw.lineLocations
        };
    }

    resetForm() {
        this.transportForm.reset();
        this.lineLocations = [];
        this.line = null;
    }
}